<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { device_ui } from 'src/stores/features/device-ui';
	import { viewComponentRegistry } from 'src/components/Sidepanel/view-registry';
	import { getCurrentView } from 'src/components/Sidepanel/view-helpers';

	export let device: Device;

	$: view = getCurrentView(device, $device_ui);

	$: component =
		viewComponentRegistry?.[view.category]?.[view.variant] ??
		viewComponentRegistry?.['remote_control']?.['basic'];
</script>

{#if component}
	<svelte:component this={component} {device} />
{/if}
